var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTag",
    {
      attrs: {
        size: _vm.size,
        color: _vm.information.color,
        icon: _vm.information.icon
      }
    },
    [_vm._v("\n    " + _vm._s(_vm.label) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }